import React from 'react'
import PropTypes from 'prop-types'
import { NavLink as Link } from 'react-router-relative-link'
import { history } from 'src/services'

function onClick() {
  // get current query params
  const search = history.location.search
  // asynchronously set them back as they were
  setTimeout(() => history.replace({ search }))
}

const NavLink = ({ to, children, style, className, exact, activeClassName, preserveQueryParams }) => {
  return (
    <Link
      to={to}
      style={style}
      className={className}
      exact={exact}
      activeClassName={activeClassName}
      onClick={preserveQueryParams ? onClick : undefined}
    >
      {children}
    </Link>
  )
}

NavLink.propTypes = {
  ...Link.propTypes,
  /**
   * Whether or not to preserve query params
   */
  preserveQueryParams: PropTypes.bool,
}

export default NavLink
